import { defaultSonarObjectsIdMapState } from './state';
import { joinSyncReducers } from '@sonar-software/xuder';
import { coreSonarObjectsIdMapAllSlice, coreSonarObjectsIdMapSlice } from './update';

export const coreSonarObjectsIdMapReducers = joinSyncReducers(
	[ coreSonarObjectsIdMapSlice.syncReducer, coreSonarObjectsIdMapAllSlice.syncReducer ],
	defaultSonarObjectsIdMapState
);
